import React from 'react';

const CustomLoginError = () => (
  <>
    Encountered unexpected behavior. Please wait for some time and try again. If
    this issue persists,
    <a
      href="mailto:rt_support@prodigaltech.com?subject=Prodigal login support | Unable to login "
      target="_blank"
      rel="noopener noreferrer"
    >
      {' '}
      please contact support
    </a>
  </>
);

export default CustomLoginError;
